
import { useLocation } from "react-router-dom";
import styles from './termsconditions.module.css'

import { BreadCrumb, Banner } from "../../components/shared/index";

function Shippingpolicy() {
  const { pathname } = useLocation();
  const parts = pathname.split("/");
  const newPath = parts[parts.length - 2];

  return (
    <section className={styles.shipping__wrapper}>
      <BreadcrumbBanner
        newPath={newPath}
        heading="Shipping Policy -GDRB Fashion"
        imageUrl="https://t4.ftcdn.net/jpg/00/54/28/13/240_F_54281395_N3triftG95Jife551rlnzHj6InhpEk9S.jpg"
      />

      <div className={styles.shipping__content}>
        <div>
          <h2>Shipping Policy –GDRB Fashion</h2>
          <p>
            We aim to provide fast, safe, and reliable delivery across India and internationally.
          </p>
        </div>

        <div>
          <h3>1. Shipping Locations</h3>
          <p>We deliver to all major cities and towns across India through trusted courier partners...</p>
        </div>

        <div>
          <h3>2. A) Shipping Charges (International)</h3>
          <ul>
            <li>Shipping charges vary depending on the destination country, package weight, and courier service.</li>
            <li>Final shipping costs will be displayed at checkout or shared by our team.</li>
            <li><b>Custom duty charges, import taxes, or VAT</b> must be paid by the customer upon delivery.</li>
          </ul>
        </div>

        <div>
          <h3>2. B) Shipping Charges (In-India)</h3>
          <ul>
            <li>A standard shipping fee of ₹100/- applies for orders below ₹1000/-</li>
            <li>Free shipping for prepaid orders above ₹1000/-</li>
            <li>Extra shipping charges apply on COD orders</li>
            <li>Shipping fees are non-refundable</li>
          </ul>
        </div>

        <div>
          <h3>3. Customs, Duties & Taxes</h3>
          <ul>
            <li>Import duties, taxes, and customs fees are not included in product or shipping charges.</li>
            <li>These fees are determined by the destination country and must be paid by the customer.</li>
            <li>We are not responsible for delays caused by customs authorities.</li>
          </ul>
        </div>

        <div>
          <h3>4. Order Processing Time</h3>
          <ul>
            <li>Orders are processed within 1–3 business days.</li>
            <li>Customized jewellery may take additional processing time depending on complexity.</li>
          </ul>
        </div>

        <div>
          <h3>5. Order Tracking</h3>
          <p>All international orders are shipped through trusted courier services...</p>
          <p>You will receive a tracking number once your order is dispatched.</p>
          <p>Tracking updates may take 24–48 hours to reflect.</p>
          <p>In-India- Once dispatched, tracking ID is sent via SMS or email.</p>
        </div>

        <div>
          <h3>6. Delivery Time</h3>
          <ul>
            <li><b>Metro Cities:</b> 3–5 working days</li>
            <li><b>Non-Metro Cities:</b> 5–7 working days</li>
            <li><b>Remote Areas:</b> 7–10 working days</li>
            <li><b>International:</b> 7–15 working days</li>
          </ul>
        </div>

        <div>
          <h3>7. Incorrect Address or Delivery Failure</h3>
          <ul>
            <li>Incorrect or incomplete address</li>
            <li>Unavailability of the customer</li>
            <li>Missed courier calls</li>
          </ul>
        </div>

        <div>
          <h3>8. Damaged or Missing Items</h3>
          <ul>
            <li>Contact us within <b>12–24 hours</b> of delivery</li>
            <li>Provide product photos, packaging images, videos, and order details for assistance.</li>
          </ul>
        </div>

        <div>
          <h3>9. Contact Us</h3>
          <p><b>Email:</b> info@gdrbtechnologies.com</p>
          <p><b>Phone:</b> +91  8886060799</p>
        </div>
      </div>
    </section>


  )
}

const BreadcrumbBanner = ({ newPath, heading, imageUrl }) => (
  <>
    <BreadCrumb customPaths={[{ label: "shipping policy", path: newPath }]} />
    <Banner heading={heading} imageUrl={imageUrl} />
  </>
);

export default Shippingpolicy;
